
//获取cookie
function getCookie(name){
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name){
            return arr[1];
        }
    }
    return "";
}
function getCookies(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}
//获取URL的值
function getParams() {
    let hrefStr = window.location.href;
    let paramObj = {};
    if (hrefStr.indexOf("?") > -1) {
        let paramArr = hrefStr.split("?")[1].split("&");
        for (let i = 0; i < paramArr.length; i++) {
            paramObj[paramArr[i].split("=")[0]] = paramArr[i].split("=")[1];
        }
    }
    return paramObj;
}
//排序
function arrs(obj){
    obj.sort(function (m, n) {
        if (m < n) return -1
        else if (m > n) return 1
        else return 0
    });
}
function TimeChange(val){
    let params=[];
    if(val){
        params[0]= val[0];
        params[1]= val[1];
    }else{
        params[0]= '';
        params[1]= '';
    }
    return params;
}
//获取当前时间
function getDates(){
    function add_10(num) {
        if (num < 10) {
            num = '0' + num
        }
        return num;
    }
    let date = new Date();
    let year = date.getFullYear(); 
    let month = date.getMonth()+1;
    let day = date.getDate();
    let hh = date.getHours();
    let mm = date.getMinutes();
    let ss = date.getSeconds();
    let dd = year+"-"+add_10(month)+"-"+add_10(day)+" "+add_10(hh)+":"+add_10(mm)+":"+add_10(ss);
    return dd;
}
//日期转换为时间戳
function dateToTime(str){
    return (new Date(str.replace(/-/g,'/'))).getTime(); //用/替换日期中的-是为了解决Safari的兼容
}
// 减法：
function dcmsub(arg1,arg2){
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    return (accMul(arg1,m)-accMul(arg2,m))/m;
}
// 乘法：
function accMul(arg1,arg2){
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}
export default {
    getCookie:function(name){
        return getCookie(name)
    },
    getCookies:function(name){
        return getCookies(name)
    },
    getParams:function(){
        return getParams()
    },
    getDates:function(){
        return getDates()
    },
    dateToTime:function(str){
        return dateToTime(str)
    },
    arrs:function(obj){
        return arrs(obj)
    },
    TimeChange:function(val,obj,obj1,obj2){
        return TimeChange(val,obj,obj1,obj2)
    },
    dcmsub(arg1,arg2){
        return dcmsub(arg1,arg2)
    },
}


// WEBPACK FOOTER //
// ./src/assets/script/common.js